<template>
<v-row>
    <v-col cols="12" md="6">
        <v-text-field
            class="pt-0"
            :label="label"
            hint="You can separate multiple email addresses using a semi-colon (;)"
            :persistent-hint="persistent_hint"
            :value="text_field_value"
            v-on:input="onChange"
        />
    </v-col>

    <v-col cols="12" md="6" class="d-flex flex-wrap gap-2">
        <v-chip
            v-for="(item, index) in value"
            :key="index"
            style="margin-right: 5px"
            close
            v-on:click:close="onRemove(index)"
        >
            {{item}}
        </v-chip>
    </v-col>
</v-row>
</template>

<script>
const _ = require('lodash');
export default {

    props: {
        label: {
            type: String,
            default: function() { return 'Email Address(es)'},
        },

        value: {
            type: Array,
            default: function() { return []; }
        },

        persistent_hint: {
            type: Boolean,
            default: false
        },
    },

    methods: {
        onChange(new_value) {
            new_value = new_value.replaceAll(',',';');

            let parts = new_value.split(';');
            let ret = [];

            for ( let i = 0; i < parts.length; i++ )
            {
                let cv = parts[i].trim();
                if ( cv.length == 0 ) continue;

                ret.push(cv);
            }

            this.$emit('input',ret);
        },

        onRemove(index)
        {
            let ret = _.cloneDeep(this.value);
            ret.splice(index,1);
            this.$emit('input',ret);
        },
    },

    computed: {
        text_field_value() {
            return this.$rc.pretty(this.value, 'semi_list');
        }
    },
}
</script>

<style lang="scss" scoped>

</style>